import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  TextField,
  EditButton,
  DateField,
  Resource,
  Show,
  Filter,
  Datagrid,
  ReferenceField,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
} from "react-admin";

const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="article.name" alwaysOn />
    <ReferenceInput label="Project" source="projectId" reference="projects" perPage={500} alwaysOn>
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const ArticleHazardousList = (props) => {
  return (
    <List {...props} filters={Filters(props)}>
      <div style={{ marginTop: "15px" }}>
        <Datagrid rowClick="show">
          {/* The /articleHazardous/:accountId endpoint embeds the related
              article, so read it directly (same pattern as ArticleMaterial).
              A ReferenceField to "articles" would call getMany('articles'),
              which hits the account-less /articles endpoint and returns
              nothing. */}
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          {/* Not sortable: the list endpoint prefixes the sort field with the hazardous alias */}
          <TextField source="project.name" label="Project" sortable={false} />
          <TextField label="Article" source="article.name" />
          <TextField label="Reference" source="article.reference" />
          <ReferenceField
            source="hazardousSubstancesId"
            reference="hazardousSubstances"
          >
            <TextField source="shortName" />
          </ReferenceField>
          <EditButton />
        </Datagrid>
      </div>
    </List>
  );
};

const ShowArticleHazardous = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField label="Article" source="article.name" />
        <TextField label="Reference" source="article.reference" />
        <ReferenceField
          source="hazardousSubstancesId"
          reference="hazardousSubstances"
        >
          <TextField source="shortName" />
        </ReferenceField>
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
      </SimpleForm>
    </Show>
  );
};

const CreateArticleHazardous = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <ReferenceInput source="articleId" reference="articles">
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput
          source="hazardousSubstancesId"
          reference="hazardousSubstances"
        >
          <AutocompleteInput optionText="shortName" />
        </ReferenceInput>
      </SimpleForm>
    </Create>
  );
};

const EditArticleHazardous = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <ReferenceInput source="articleId" reference="articles">
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput
          source="hazardousSubstancesId"
          reference="hazardousSubstances"
        >
          <AutocompleteInput optionText="shortName" />
        </ReferenceInput>
      </SimpleForm>
    </Edit>
  );
};

const articleHazardousResource = () => (
  <Resource
    name="articleHazardous"
    options={{ label: "Article hazardous", menuGroup: "Articles" }}
    list={ArticleHazardousList}
    create={CreateArticleHazardous}
    edit={EditArticleHazardous}
    show={ShowArticleHazardous}
  />
);

export default articleHazardousResource;
